const uiWarOfRights = {
  href: "/portfolio/ui-war-of-rights/",
  img: "/assets/images/20190103151822_1.jpg",
  title: "UI - War of Rights",
  description: "Was in charge of updating the current ingame and menu UI to 4K. The UI was created in Flash ActionScript 2 with Scaleform elements. Everything was overhauled, new features were added, such as new ingame popup notices, dynamic UI to fit widescreen resolution, and dynamic menu elements."
};

export default uiWarOfRights;